import Model, { attr } from '@ember-data/model';

export default class EmpresaModel extends Model {
  @attr('number') _id;
  @attr('string') codempresa;
  @attr('string') codmoneda;
  @attr('string') nombreemp;
  @attr('string') razonsocial;
  @attr('string') direccionemp;
  @attr('string') telefonoemp;
  @attr('string') emailemp;
  @attr('string') webpageemp;
  @attr('string') nitemp;
}
